import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { SystemStyleObject } from '@mui/system';
import range from 'lodash/range';
import React, { FC } from 'react';

import { LabwareSlotItem } from './LabwareSlotItem';

import type { LabwareSlotData } from '.';

interface Props {
  sx?: SystemStyleObject;
  slots: number;
  labwareSlotData: LabwareSlotData;
}

export const CarouselDeckVisualization: FC<Props> = (props) => {
  const { sx, slots, labwareSlotData } = props;

  const slotHeightRem = 3;

  // To put slot 1 at the bottom, rotate CCW by 1/4 turn (Slot 1 would otherwise be at the leftmost position)
  const SLOT_TURN_OFFSET = -0.25;

  return (
    <Box>
      <Box
        sx={[
          {
            backgroundColor: 'grey.100',
            borderRadius: '50%',
            aspectRatio: '1 / 1',
            borderWidth: '3px',
            position: 'relative',
            borderStyle: 'solid',
            borderColor: 'grey.300',
          },
          sx ?? null,
        ]}
      >
        {range(slots).map((index) => {
          const slot = index + 1;
          const turn = index / slots + SLOT_TURN_OFFSET;
          // flip if it passes 12 o'clock so the text isn't upside down
          const flip = turn > 0.25;

          const labwareData = labwareSlotData.find(
            (item) => item.slot === slot
          )?.data;
          // Outer Box spans diameter of the circle, to rotate its children
          return (
            <Box
              key={slot}
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transformOrigin: 'center',
                transform: `translate(-50%, -50%) rotate(${turn}turn)`,
                width: '100%',
              }}
            >
              <Stack direction="row" alignItems="center" paddingLeft="1rem">
                <LabwareSlotItem
                  colorIndex={labwareData?.colorIndex}
                  nickname={labwareData?.labwareName}
                  slotHeightRem={slotHeightRem}
                  slot={slot}
                  flip={flip}
                />
                <Typography
                  component="div"
                  variant="body2"
                  sx={{
                    color: 'grey.600',
                    fontWeight: 'semibold',
                    padding: '0 1rem',
                    transform: `rotate(${-turn}turn)`, // counter the parent's rotation
                  }}
                >
                  {slot}
                </Typography>
              </Stack>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
